<cm-overlay header="Error">
    <div class="error-message">
        <div>{{ errorTitle }}</div>
        <div>{{ errorMessage }}</div>
    </div>
    <cm-choice-selector [choices]="[{id: 0, label: 'OK'}]" (choiceSelected)="onOk($event)"></cm-choice-selector>
</cm-overlay>
